import { ILocationData } from "@/sg-kohderekisterit/IKohderekisteri";
import { IFormSchema } from "./IFormSchema";
import { IImage } from "./IImage";



export interface IAuditNote {
    id: number;
    key: string;
    title: string;
    details: string;
    images?: IImage[];

    relatedObservation?: number;
    submitStatus?: "submitted" | "unsubmitted" | "submitError",

    unsubmitted?: false;
    formData?: { [key: string]: any };

    fieldTitle: string;

    eventTime?: Date | null | string;

    creator: number;
    target: ILocationData["id"];

};

export type INewAuditNote = Omit<IAuditNote, "relatedObservation" | "id">;

export interface IUnsubmittedAuditNote {
    id: number;
    key: string;
    unsubmitted: true;
    submitStatus: "unsubmitted" | "submitError";
    observationSchema?: IFormSchema;
    formType?: number;

    formData?: IAuditNoteFormData//    { [key: string]: any };
}

export type TEditableAuditNote = IAuditNote | IUnsubmittedAuditNote

interface IControlledObservationFormFields {
    informer: "ilmottaja",
    target: "sijainti",
    eventTime: "tapahtuma_aika",
    title: "otsikko",
    details: "kuvaus",
    images: "kuvat",
    image: "kuva"
};


export const ControlledObservationFormFields: IControlledObservationFormFields = {
    informer: "ilmottaja",
    target: "sijainti",
    eventTime: "tapahtuma_aika",
    title: "otsikko",
    details: "kuvaus",
    images: "kuvat",
    image: "kuva"
};


export type IAuditNoteFormData = Partial<IAuditNote> & {
    makeObservation?: boolean;

    otsikko?: string;
    kuvaus?: string;

    sijainti?: ILocationData["id"];
    ilmottaja?: number | string;
    tapahtuma_aika?: Date | null | string;

    kuvat?: IImage[];
    kuva?: IImage;
};


